import { BorderColor } from "@mui/icons-material";

export const compStyleOverride = (theme) => {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          fontSize: "16px",
          lineHeight: "24px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          padding: "8px 12px",
          // fontSize: "14px",
          // lineHeight: "21px",
        },
        sizeMedium: {
          padding: "10px 15px",
          // fontSize: "15px",
          // lineHeight: "22px",
        },
        sizeLarge: {
          padding: "15px 20px",
          // fontSize: "18px",
          // lineHeight: "25px",
        },
      },
    },
  };
};
